import Chip, { ChipProps } from '@mui/material/Chip'
import { styled } from '@mui/material/styles'

interface LinkChipProps extends ChipProps {
  iconPos?: 'left' | 'right'
  largeLabel?: string
}

const LeftChip = styled(Chip)(({ theme }) => ({
  gap: '0.5rem', // spacing between icon and label

  '& .MuiChip-label .largeLabel': {
    display: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    '& .MuiChip-label': {
      '& .largeLabel': {
        display: 'inherit',
      },
      '& .smallLabel': {
        display: 'none',
      },
    },
  },
}))

const RightChip = styled(LeftChip)(() => ({
  flexDirection: 'row-reverse',
}))

export const LinkChip = ({
  label,
  iconPos = 'left',
  ...props
}: LinkChipProps): JSX.Element => {
  const responsiveLabel =
    props.largeLabel == null ? (
      label
    ) : (
      <>
        <span className='largeLabel'>{props.largeLabel}</span>
        <span className='smallLabel'>{label}</span>
      </>
    )
  const DirectionalChip = iconPos === 'left' ? LeftChip : RightChip
  return <DirectionalChip variant='subtle' label={responsiveLabel} {...props} />
}
